import * as React from 'react';

import { CheckoutSegmentProps } from '../../types';
import SegmentCompact from './SegmentCompact/SegmentCompact';
import SegmentCommon from './SegmentCommon/SegmentCommon';

interface Props extends CheckoutSegmentProps {
	variant: 'compact' | 'common';
}

const Segment: React.FC<Props> = ({ variant, ...props }) => {
	if (variant === 'compact') {
		return <SegmentCompact {...props} />;
	}

	return <SegmentCommon {...props} />;
};

export default Segment;
